const palette = {
    ColorA: "#6A5B6E",
    ColorB: "#F68E5F",
    ColorC: "#DECDF5",
    ColorD: "#7CDEDC",
    ColorE: "#DBDFAC",
    ColorF: "#de7cbc",
}

export default palette